import { FieldError } from "event-definitions"
import { useEffect } from "react"
import { useBoundContext } from "../../../binding/use-bound-context"
import { ExtendedSelectErrorChecker } from "slot-definitions"
import { hasValue } from "lib/@components/extended-select/plugins/required-field-error/has-value"

export const FIELD_ERROR_REQUIRED = "required"

ExtendedSelectErrorChecker.plug(<RequiredFieldError />)

export function RequiredFieldError() {
    const { required, hasSelectedValue, label, selectId, mapping } = useBoundContext()

    useEffect(() => {
        const eventPayload = { id: selectId, field: label, errorType: FIELD_ERROR_REQUIRED }

        if (required && !hasSelectedValue && !hasValue(mapping)) {
            FieldError(selectId)(FIELD_ERROR_REQUIRED).raise({
                ...eventPayload,
                error: true,
            })
        }
        return () =>
            FieldError(selectId)(FIELD_ERROR_REQUIRED).raise({
                ...eventPayload,
                error: false,
            })
    }, [selectId, label, required, hasSelectedValue, mapping])
}
